{
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.closing.no-translate": [
    {
      "type": 0,
      "value": "Happy planning!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.completion-note.no-translate": [
    {
      "type": 0,
      "value": "If you've already completed these steps, you're good to go."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.cta-button.no-translate": [
    {
      "type": 0,
      "value": "Open your plan"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.intro.no-translate": [
    {
      "type": 0,
      "value": "You've created a new Jira plan “"
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": "”. Now let's unlock its full power."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.see-big-picture.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "See the big picture"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Your plan brings together work across teams, projects and releases into one roadmap."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.signature.no-translate": [
    {
      "type": 0,
      "value": "- The Jira Plans team – Atlassian"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.stay-realistic.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Stay realistic"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Adjust your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "timeline view"
        }
      ],
      "type": 8,
      "value": "linkToTimelinePage"
    },
    {
      "type": 0,
      "value": ", filter and group by fields, and explore Capacity and Velocity. All so you know what your team can deliver and when."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.turn-work-commitments.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Turn work into commitments"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Edit or create work items, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "assign your team"
        }
      ],
      "type": 8,
      "value": "linkToTeamPage"
    },
    {
      "type": 0,
      "value": ", and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "link work with dependencies"
        }
      ],
      "type": 8,
      "value": "linkToDependenciesPage"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "releases"
        }
      ],
      "type": 8,
      "value": "linkToReleasesPage"
    },
    {
      "type": 0,
      "value": " so everyone knows what comes next."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.email.body.visualize-results.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Visualize results"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Use the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Summary"
        }
      ],
      "type": 8,
      "value": "linkToSummary"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Calendar"
        }
      ],
      "type": 8,
      "value": "linkToCalendar"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Dependencies"
        }
      ],
      "type": 8,
      "value": "linkToDependencies"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Program Board"
        }
      ],
      "type": 8,
      "value": "linkToProgramBoard"
    },
    {
      "type": 0,
      "value": " views to track progress, avoid surprises and keep delivery on track."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-deep-links.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your next steps in "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " to plan and track complex work confidently"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.closing.no-translate": [
    {
      "type": 0,
      "value": "Happy planning!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.completion-note.no-translate": [
    {
      "type": 0,
      "value": "If you've already completed these steps, you're good to go."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.cta-button.no-translate": [
    {
      "type": 0,
      "value": "Open your plan"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.intro.no-translate": [
    {
      "type": 0,
      "value": "You've created a new Jira plan “"
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": "”. Now let's unlock its full power."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.see-big-picture.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "See the big picture"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Your plan "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "brings together work across teams, projects and releases"
        }
      ],
      "type": 8,
      "value": "linkToBigPictureDocs"
    },
    {
      "type": 0,
      "value": " into one roadmap."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.signature.no-translate": [
    {
      "type": 0,
      "value": "- The Jira Plans team – Atlassian"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.stay-realistic.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Stay realistic"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Adjust your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "timeline view, filter and group by fields"
        }
      ],
      "type": 8,
      "value": "linkToTimelineDocs"
    },
    {
      "type": 0,
      "value": ", and explore "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Capacity and Velocity"
        }
      ],
      "type": 8,
      "value": "linkToCapacityAndVelocityDocs"
    },
    {
      "type": 0,
      "value": ". All so you know what your team can deliver and when."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.turn-work-commitments.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Turn work into commitments"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Edit or create "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "work items"
        }
      ],
      "type": 8,
      "value": "linkToWorkItemsDocs"
    },
    {
      "type": 0,
      "value": ", assign your "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "team"
        }
      ],
      "type": 8,
      "value": "linkToTeamDocs"
    },
    {
      "type": 0,
      "value": ", and link work with "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "dependencies"
        }
      ],
      "type": 8,
      "value": "linkToDependenciesDocs"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "releases"
        }
      ],
      "type": 8,
      "value": "linkToReleasesDocs"
    },
    {
      "type": 0,
      "value": " so everyone knows what comes next."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.email.body.visualize-results.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Visualize results"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Use the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Summary"
        }
      ],
      "type": 8,
      "value": "linkToSummaryDocs"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Calendar"
        }
      ],
      "type": 8,
      "value": "linkToCalendarDocs"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Dependencies"
        }
      ],
      "type": 8,
      "value": "linkToDependenciesDocs"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Program Board"
        }
      ],
      "type": 8,
      "value": "linkToProgramBoardDocs"
    },
    {
      "type": 0,
      "value": " views to track progress, avoid surprises and keep delivery on track."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-doc-links.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your next steps in "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " to plan and track complex work confidently"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.closing.no-translate": [
    {
      "type": 0,
      "value": "Happy planning!"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.completion-note.no-translate": [
    {
      "type": 0,
      "value": "If you've already completed these steps, you're good to go."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.cta-button.no-translate": [
    {
      "type": 0,
      "value": "Open your plan"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.documentation-link.no-translate": [
    {
      "type": 0,
      "value": "Learn more about Jira Plans."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.greeting.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.intro.no-translate": [
    {
      "type": 0,
      "value": "You've created a new Jira plan “"
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": "”. Now let's unlock its full power."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.see-big-picture.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "See the big picture"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Your plan brings together work across teams, projects and releases into one roadmap."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.signature.no-translate": [
    {
      "type": 0,
      "value": "- The Jira Plans team – Atlassian"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.stay-realistic.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Stay realistic"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Adjust your timeline view, filter and group by fields, and explore Capacity and Velocity. All so you know what your team can deliver and when."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.turn-work-commitments.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Turn work into commitments"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Edit or create work items, assign your team, and link work with dependencies or releases so everyone knows what comes next."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.unsubscribe.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.email.body.visualize-results.no-translate": [
    {
      "children": [
        {
          "type": 0,
          "value": "Visualize results"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": ". Use the Summary, Calendar, Dependencies and Program Board views to track progress, avoid surprises and keep delivery on track."
    }
  ],
  "jira-chronos.jira-plan-created-reminder-experiment-single-cta.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your next steps in "
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": " to plan and track complex work confidently"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.avatar.no-translate": [
    {
      "type": 0,
      "value": "avatar"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.blueprint.no-translate": [
    {
      "type": 0,
      "value": "blueprintLogo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.collborate.message": [
    {
      "type": 0,
      "value": "Collaborate, align, and deliver work, all in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " one place "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.collect.message": [
    {
      "type": 0,
      "value": "Collect and send work to other teams or stakeholders using "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " forms "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.globe.no-translate": [
    {
      "type": 0,
      "value": "globeLogo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.invited-message": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": "  invited you to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " "
        },
        {
          "type": 1,
          "value": "planTitle"
        },
        {
          "type": 0,
          "value": " "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.join.link": [
    {
      "type": 0,
      "value": "Join the Plan"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.learn.more.message": [
    {
      "type": 0,
      "value": "Learn more about Jira"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.logo.no-translate": [
    {
      "type": 0,
      "value": "logo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.contactus.template": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.copyright.template": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.location.template": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.privacy.policy.template.dot": [
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.use.jira.generic.message": [
    {
      "type": 0,
      "value": "Use Jira to..."
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.view.work.message": [
    {
      "type": 0,
      "value": "View work your way using the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " list, board, calendar "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " timeline "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " views"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.body.write.no-translate": [
    {
      "type": 0,
      "value": "writeLogo"
    }
  ],
  "jira-chronos.jira-plans-user-invited.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": ") invited you to ("
    },
    {
      "type": 1,
      "value": "planTitle"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "jira-plan-add-user-changeboarding.message-templates.spotlight-body": [
    {
      "type": 0,
      "value": "Use "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Add people"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " in this menu to share this plan with people outside of your organization."
    }
  ],
  "jira-plan-add-user-changeboarding.message-templates.spotlight-cta": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-plan-add-user-changeboarding.message-templates.spotlight-header": [
    {
      "type": 0,
      "value": "Spread the good word"
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.description": [
    {
      "type": 0,
      "value": "Fields that aren’t part of a space’s configuration can no longer be used in your plan. Add the fields to your space to use them again."
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.goToSettings": [
    {
      "type": 0,
      "value": "Go to settings"
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.read-more": [
    {
      "type": 0,
      "value": "Read more"
    }
  ],
  "jira-plans-efa-change-boarding.message-templates.flag.title": [
    {
      "type": 0,
      "value": "Some fields in your plan have been deactivated."
    }
  ]
}